import { CommissionRow } from './CommissionRow';
import { getCommissionValue } from './getCommissionValue';

export const comissionToCsv = (commissions: CommissionRow[]) => {
    let csv: Array<Array<any>> = [];
    csv.push(['Carrier', 'Sku', 'Comisión']);

    commissions.forEach((element) => {
        if (element.commission) {
            csv.push([element.commission.carrier, element.commission.sku, getCommissionValue(element.commission)]);
        }
    });
    return csv;
}
